import { useEffect, useState } from 'react';

const read = (q) => (typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(q).matches : false);

// Tracks a media query (SSR-safe); used for reduced motion and the desktop/mobile video pick.
export function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => read(query));
  useEffect(() => {
    const mq = window.matchMedia(query);
    const onChange = (e) => setMatches(e.matches);
    setMatches(mq.matches);
    mq.addEventListener ? mq.addEventListener('change', onChange) : mq.addListener(onChange);
    return () => (mq.removeEventListener ? mq.removeEventListener('change', onChange) : mq.removeListener(onChange));
  }, [query]);
  return matches;
}

export const useReducedMotion = () => useMediaQuery('(prefers-reduced-motion: reduce)');
